module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "barpos-screen"
  }, [_c('div', {
    staticClass: "bar-pos-page",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.onKeyDown
    }
  }, [_c('header', {
    staticClass: "pos-header"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("🏋️‍♂️")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_bar_pos')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_quick_sell')))])])]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, _vm._l((_vm.locations), function(c) {
    return _c('button', {
      key: c,
      staticClass: "chip",
      class: {
        active: _vm.selectedLocation === c
      },
      on: {
        "click": function($event) {
          return _vm.selectLocation(c)
        }
      }
    }, [_vm._v(_vm._s(c) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("🔎")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      active: _vm.activeCategory === null
    },
    on: {
      "click": function($event) {
        _vm.activeCategory = null
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_all')) + "\n            ")]), _vm._v(" "), _vm._l((_vm.categories), function(c) {
    return _c('button', {
      key: c,
      staticClass: "chip",
      class: {
        active: _vm.activeCategory === c
      },
      on: {
        "click": function($event) {
          _vm.activeCategory = c
        }
      }
    }, [_vm._v(_vm._s(c) + "\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": function($event) {
        return _vm.openProfits()
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_profit')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.filteredProducts), function(p) {
    return _c('button', {
      key: p.id,
      staticClass: "tile",
      attrs: {
        "disabled": p.stockNumber <= 0
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(p)
        }
      }
    }, [_c('div', {
      staticClass: "tile-top"
    }, [_c('div', {
      staticClass: "tile-name"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
      staticClass: "tile-price"
    }, [_vm._v(_vm._s(_vm.money(p.price)))])]), _vm._v(" "), _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": p.imageMain,
        "alt": "product image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tile-bottom"
    }, [(p.parentOrderUuid == null) ? _c('span', {
      staticClass: "badge",
      class: _vm.stockClass(p)
    }, [_vm._v(_vm._s(_vm.stockLabel(p)))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('aside', {
    staticClass: "cart"
  }, [_c('div', [_c('cash-register-widget', {
    attrs: {
      "amount": _vm.currentCash,
      "currency": "RSD"
    },
    on: {
      "open-cash-register": function($event) {
        return _vm.openBills()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "customer-panel"
  }, [_c('div', {
    staticClass: "cart-actions"
  }, [_c('button', {
    staticClass: "cart-confirm-button",
    staticStyle: {
      "width": "49%"
    },
    on: {
      "click": function($event) {
        return _vm.openCustomBill(false)
      }
    }
  }, [_vm._v("\n                + " + _vm._s(_vm.locale.t('label_create_custom_bill')) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "cart-confirm-button cashout",
    staticStyle: {
      "width": "49%"
    },
    on: {
      "click": function($event) {
        return _vm.openCustomBill(true)
      }
    }
  }, [_vm._v("\n                - " + _vm._s(_vm.locale.t('label_cash_cashout')) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cart-head"
  }, [_c('div', {
    staticClass: "cart-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_cart')))]), _vm._v(" "), _c('div', {
    staticClass: "cart-sub"
  }, [_vm._v(_vm._s(_vm.locale.t('label_cart_items')) + ": " + _vm._s(_vm.totalQty))])]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', [_c('div', {
    staticClass: "cart-sub"
  }, [_vm._v(_vm._s(_vm.locale.t('label_cart_description')))])]) : _vm._e(), _vm._v(" "), (_vm.cart.length) ? _c('div', {
    staticClass: "cart-items"
  }, _vm._l((_vm.cart), function(it, idx) {
    return _c('div', {
      key: it.productId,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-main"
    }, [_c('div', {
      staticClass: "qty"
    }, [_c('button', {
      staticClass: "qty-btn",
      on: {
        "click": function($event) {
          return _vm.decQty(idx)
        }
      }
    }, [_vm._v("−")]), _vm._v(" "), _c('span', {
      staticClass: "qty-val"
    }, [_vm._v(_vm._s(it.qty))]), _vm._v(" "), _c('button', {
      staticClass: "qty-btn",
      on: {
        "click": function($event) {
          return _vm.incQty(idx)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
      staticClass: "name",
      attrs: {
        "title": it.name
      }
    }, [_vm._v(_vm._s(it.name))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.cart.length) ? _c('div', {
    staticClass: "cart-items"
  }, [_c('div', {
    staticClass: "cart-summary dark"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_amount')))]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.getTotalPrice())))])]), _vm._v(" "), (_vm.selectedDiscount && _vm.selectedDiscount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n                    " + _vm._s(_vm.locale.t('label_discount')) + "\n                    "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("-" + _vm._s(_vm.selectedDiscount) + "%")])]), _vm._v(" "), _c('span', {
    staticClass: "value discount"
  }, [_vm._v("\n                    -" + _vm._s(_vm.formatMoney(_vm.getDiscountAmount())) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedDiscount && _vm.selectedDiscount > 0) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row total"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_amount_with_discount')))]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.getTotalPriceWithDiscount())))])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cart-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_discount')))]), _vm._v(" "), (_vm.cart.length) ? _c('div', {
    staticClass: "chips discount-margin"
  }, [_vm._l((_vm.discounts), function(c) {
    return _c('button', {
      key: c,
      staticClass: "chip",
      class: {
        active: Number(_vm.selectedDiscount) === c
      },
      on: {
        "click": function($event) {
          return _vm.selectDiscount(c)
        }
      }
    }, [_vm._v("\n                " + _vm._s(c) + " %\n              ")])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDiscount),
      expression: "selectedDiscount"
    }],
    staticClass: "chip",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_insert_discount'),
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.selectedDiscount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedDiscount = $event.target.value
      }
    }
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.cart.length) ? _c('div', {
    staticClass: "customer-panel"
  }, [(!_vm.showCustomerForm && _vm.selectedUser == null) ? [_c('button', {
    staticClass: "add-user-btn",
    on: {
      "click": function($event) {
        _vm.showCustomerForm = true
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.locale.t('label_add_user')))])] : _vm._e(), _vm._v(" "), [(_vm.selectedUser != null) ? _c('div', {
    staticClass: "user-inputs"
  }, [_c('button', {
    staticClass: "add-user-btn",
    on: {
      "click": function($event) {
        _vm.selectedUser = null;
      }
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v("\n                  " + _vm._s(_vm.selectedUser.name) + " " + _vm._s(_vm.selectedUser.surname) + " " + _vm._s('(' + (_vm.selectedUser.barBalance != null ? _vm.selectedUser.barBalance : 0) + ')')), _c('i', {
    staticClass: "ti-trash",
    staticStyle: {
      "color": "red"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', [_c('button', {
    staticClass: "chip",
    class: {
      activered: _vm.notPaid === true
    },
    on: {
      "click": function($event) {
        _vm.notPaid = !_vm.notPaid;
        _vm.paidWithCredits = false;
      }
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.notPaid ? '✔ ' : '') + " " + _vm._s(_vm.locale.t('label_bar_pos_debt')) + "\n                    ")])]), _vm._v(" "), (_vm.useCredits && !_vm.useSaldoInsteadCreditOnMobileApp) ? _c('span', [_c('button', {
    staticClass: "chip",
    class: {
      paidWithCredit: _vm.paidWithCredits === true
    },
    on: {
      "click": function($event) {
        _vm.paidWithCredits = !_vm.paidWithCredits;
        _vm.notPaid = false;
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.paidWithCredits ? '✔ ' : '') + " " + _vm._s(_vm.locale.t('label_pay_with_credits')) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cart-actions"
  }, [_c('button', {
    staticClass: "cart-confirm-button cancel",
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": function($event) {
        return _vm.cancelBill()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_cancel')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "cart-confirm-button green",
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": function($event) {
        return _vm.confirmCheckout()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_cart_approve')) + "\n                ")])])]], 2) : _vm._e()])]), _vm._v(" "), (_vm.showReceipts) ? _c('div', {
    staticClass: "drawer-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeReceipts.apply(null, arguments)
      }
    }
  }, [_c('aside', {
    staticClass: "receipts-drawer",
    attrs: {
      "role": "dialog",
      "aria-label": "Receipts"
    }
  }, [_c('header', {
    staticClass: "receipts-head"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_bills')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.filteredReceipts.length) + " " + _vm._s(_vm.locale.t('label_cart_items')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": _vm.closeReceipts
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-filters"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap section-top-xs"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("🔎")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiptSearch),
      expression: "receiptSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.receiptSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiptSearch = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      active: _vm.groupBy === 'user'
    },
    on: {
      "click": function($event) {
        _vm.groupBy = 'user'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_group_by_user')) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "chip",
    class: {
      active: _vm.groupBy === 'product'
    },
    on: {
      "click": function($event) {
        _vm.groupBy = 'product'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_group_by_product')) + "\n              ")])])]), _vm._v(" "), (!_vm.receiptsLoading && _vm.filteredReceipts.length) ? _c('div', {
    staticClass: "receipts-body"
  }, _vm._l((_vm.filteredReceipts), function(b) {
    return _c('button', {
      key: b.id,
      staticClass: "receipt-line",
      on: {
        "click": function($event) {
          b.expanded = !b.expanded
        }
      }
    }, [_c('div', {
      staticClass: "receipt-top"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": b.name
      }
    }, [_vm._v("\n                    " + _vm._s(b.name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(b.createdTime)))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "total"
    }, [_vm._v(_vm._s(_vm.money(b.total, _vm.locale.t('label_currency'))))]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v("#" + _vm._s(b.id))]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.locale.t('label_sell_product')) + ": " + _vm._s(b.count))])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(b.items && b.items.length && b.expanded && _vm.groupBy === 'user') ? _c('ul', {
      staticClass: "receipt-items"
    }, _vm._l((b.items), function(it) {
      return _c('li', {
        key: it.id,
        staticClass: "receipt-item"
      }, [_c('div', {
        staticClass: "item-left"
      }, [_c('img', {
        staticClass: "item-thumb",
        attrs: {
          "src": it.imageMain,
          "alt": ""
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "item-name"
      }, [_vm._v(_vm._s(it.name))])]), _vm._v(" "), _c('div', {
        staticClass: "item-right"
      }, [_c('span', {
        staticClass: "item-price"
      }, [_vm._v(_vm._s(_vm.money(it.amount, _vm.locale.t('label_currency'))))])])])
    }), 0) : _vm._e(), _vm._v(" "), (b.items && b.items.length && b.expanded && _vm.groupBy === 'product') ? _c('ul', {
      staticClass: "receipt-items"
    }, _vm._l((b.items), function(it) {
      return _c('li', {
        key: it.id,
        staticClass: "receipt-item"
      }, [_c('div', {
        staticClass: "item-left"
      }, [_c('span', {
        staticClass: "item-name"
      }, [_vm._v(_vm._s(it.firstName) + " " + _vm._s(it.lastName))])]), _vm._v(" "), _c('div', {
        staticClass: "item-right"
      }, [_c('span', {
        staticClass: "item-price"
      }, [_vm._v(_vm._s(_vm.money(it.amount, _vm.locale.t('label_currency'))))])])])
    }), 0) : _vm._e()])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.receiptsLoading && !_vm.filteredReceipts.length) ? _c('div', {
    staticClass: "receipts-empty"
  }, [_c('div', [_vm._v("😐 " + _vm._s(_vm.locale.t('label_nothing_found')))])]) : _vm._e(), _vm._v(" "), (_vm.receiptsLoading) ? _c('div', {
    staticClass: "receipts-loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "receipts-foot"
  }, [(_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showBills) ? _c('div', {
    staticClass: "drawer-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeBills.apply(null, arguments)
      }
    }
  }, [_c('aside', {
    staticClass: "bills-drawer",
    class: {
      'bills-drawer--full': _vm.isAdvancedSearch
    },
    attrs: {
      "role": "dialog",
      "aria-label": "Receipts"
    }
  }, [_c('header', {
    staticClass: "receipts-head"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_bills')))]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "title"
  }, [_vm._v("💵 Stanje kase: " + _vm._s(_vm.amountByCategory) + " " + _vm._s(_vm.locale.t('label_currency')))]), _vm._v(" "), _c('b', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.filteredBills.length) + " " + _vm._s(_vm.locale.t('label_cart_items')))])]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "title"
  }, [_vm._v("💵 Promet: " + _vm._s(_vm.salesByCategory) + " " + _vm._s(_vm.locale.t('label_currency')))]), _vm._v(" "), _c('b', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.filteredBills.length) + " " + _vm._s(_vm.locale.t('label_cart_items')))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": _vm.toggleAdvancedSearch
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isAdvancedSearch ? _vm.locale.t('label_simple_search') : _vm.locale.t('label_advanced_search')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": _vm.closeBills
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-filters"
  }, [(!_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "search-main-wrap"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-wrap section-top-xs"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("🔎")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiptSearch),
      expression: "receiptSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.receiptSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiptSearch = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top"
  }, [_c('button', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.doSearch();
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_search')))])]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      active: _vm.selectedBillCategory === null
    },
    on: {
      "click": function($event) {
        return _vm.selectBillCategory(null)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_all')) + "\n              ")]), _vm._v(" "), _vm._l((_vm.billCategories), function(c) {
    return _c('button', {
      key: c.id,
      staticClass: "chip",
      class: {
        active: _vm.selectedBillCategory != null ? _vm.selectedBillCategory.id === c.id : false
      },
      on: {
        "click": function($event) {
          return _vm.selectBillCategory(c)
        }
      }
    }, [_vm._v(_vm._s(c.label) + "\n              ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      activered: _vm.filterNotPaid === true
    },
    on: {
      "click": function($event) {
        _vm.filterNotPaid = !_vm.filterNotPaid;
        _vm.filterPaidWithCredit = false;
        _vm.loadBills();
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filterNotPaid ? '✔ ' : '') + " " + _vm._s(_vm.locale.t('label_bar_pos_debt')) + "\n              ")]), _vm._v(" "), (_vm.useCredits && !_vm.useSaldoInsteadCreditOnMobileApp) ? _c('button', {
    staticClass: "chip",
    class: {
      paidWithCredit: _vm.filterPaidWithCredit === true
    },
    on: {
      "click": function($event) {
        _vm.filterPaidWithCredit = !_vm.filterPaidWithCredit;
        _vm.filterNotPaid = false;
        _vm.loadBills();
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filterPaidWithCredit ? '✔ ' : '') + " " + _vm._s(_vm.locale.t('label_paid_with_credits')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), (!_vm.receiptsLoading && _vm.filteredBills.length) ? _c('div', {
    staticClass: "receipts-body"
  }, _vm._l((_vm.filteredBills), function(b) {
    return _c('div', {
      key: b.id,
      staticClass: "receipt-line",
      on: {
        "click": function($event) {
          return _vm.showBillDetails(b)
        }
      }
    }, [_c('div', {
      staticClass: "receipt-top"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": b.name
      }
    }, [_vm._v("\n                    " + _vm._s(b.name) + " " + _vm._s(b.billUuid) + "\n                    "), (b.username != null && !b.username.includes('_shop')) ? _c('span', {
      staticClass: "chip",
      staticStyle: {
        "height": "10px"
      }
    }, [_vm._v(_vm._s(b.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(b.createdTimestamp * 1000)))])]), _vm._v(" "), (b.productDetails != null) ? _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(b.productDetails))])]) : _vm._e(), _vm._v(" "), (b.productDetails == null && (b.comment != null && b.comment.length > 0)) ? _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(b.comment))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.translateStatus(b)))]), _vm._v(" "), (_vm.canCancelBill(b)) ? _c('span', [_c('button', {
      staticClass: "cart-confirm-button storn",
      staticStyle: {
        "height": "25px"
      },
      on: {
        "click": function($event) {
          return _vm.stornBill(b)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_bill_cancel')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (b.notPaid != null && b.notPaid === true) ? _c('span', [_c('button', {
      staticClass: "cart-confirm-button storn",
      staticStyle: {
        "height": "25px"
      },
      on: {
        "click": function($event) {
          return _vm.setPaidBill(b)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_bar_pos_debt')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (b.paidWithCredits != null && b.paidWithCredits === true) ? _c('span', [_c('div', {
      staticClass: "cart-confirm-button cashout",
      staticStyle: {
        "height": "25px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.locale.t('label_paid_with_credits')) + "\n                      ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "total",
      style: (b.type === 'MINUS' ? 'color: red;' : 'color: green')
    }, [_c('b', [_vm._v(_vm._s(b.type === 'MINUS' ? '-' : '+') + _vm._s(_vm.money(b.amount, _vm.locale.t('label_currency'))))])]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v("#" + _vm._s(b.id))]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.locale.t('label_sell_product')) + ": " + _vm._s(b.totalItems))])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(b.loadingItems) ? _c('my-loader', {
      staticClass: "centered-div"
    }) : _vm._e(), _vm._v(" "), (b.items && b.items.length && b.expanded) ? _c('ul', {
      staticClass: "receipt-items"
    }, _vm._l((b.items), function(it) {
      return _c('li', {
        key: it.id,
        staticClass: "receipt-item"
      }, [_c('div', {
        staticClass: "item-left"
      }, [(it.image != null) ? _c('img', {
        staticClass: "item-thumb",
        attrs: {
          "src": it.image,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (it.image == null) ? _c('div', {
        staticClass: "cash-widget__icon",
        staticStyle: {
          "width": "20px",
          "height": "20px"
        }
      }, [_vm._v("💵")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "item-name"
      }, [_vm._v(_vm._s(it.name))])]), _vm._v(" "), _c('div', {
        staticClass: "item-right"
      }, [_c('span', {
        staticClass: "item-price"
      }, [_vm._v(_vm._s(_vm.money(it.price, _vm.locale.t('label_currency'))))])])])
    }), 0) : _vm._e()], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.receiptsLoading && !_vm.filteredBills.length) ? _c('div', {
    staticClass: "receipts-empty"
  }, [_c('div', [_vm._v("😐 " + _vm._s(_vm.locale.t('label_nothing_found')))])]) : _vm._e(), _vm._v(" "), (_vm.receiptsLoading) ? _c('div', {
    staticClass: "receipts-loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "receipts-foot"
  }, [(_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showCustomBill) ? _c('div', {
    staticClass: "drawer-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeCustomBill.apply(null, arguments)
      }
    }
  }, [_c('aside', {
    staticClass: "receipts-drawer",
    attrs: {
      "role": "dialog",
      "aria-label": "Create custom bill"
    }
  }, [_c('header', {
    staticClass: "receipts-head"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_create_custom_bill')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_fill_custom_bill')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": _vm.closeCustomBill
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-filters"
  }, [_c('div', {
    staticClass: "search-wrap section-top-xs"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_name')) + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customBill.name),
      expression: "customBill.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search",
    class: {
      'error': _vm.customBillErrors.name
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_bill_enter_name')
    },
    domProps: {
      "value": (_vm.customBill.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customBill, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap section-top-xs"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_amount')) + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.customBill.amount),
      expression: "customBill.amount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "search",
    class: {
      'error': _vm.customBillErrors.amount
    },
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": _vm.locale.t('label_bill_enter_amount')
    },
    domProps: {
      "value": (_vm.customBill.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customBill, "amount", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap section-top-xs"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_comment')) + "\n              ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customBill.comment),
      expression: "customBill.comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search",
    attrs: {
      "rows": "3",
      "placeholder": _vm.locale.t('label_bill_optional_comment')
    },
    domProps: {
      "value": (_vm.customBill.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customBill, "comment", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-body"
  }, [(_vm.customBillErrorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n              " + _vm._s(_vm.customBillErrorMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "chips discount-margin section-bottom-sm"
  }, _vm._l((_vm.billCategories), function(c) {
    return _c('button', {
      key: c.id,
      staticClass: "chip",
      class: {
        active: _vm.selectedBillCategory != null ? _vm.selectedBillCategory.id === c.id : false
      },
      on: {
        "click": function($event) {
          return _vm.selectBillCategory(c)
        }
      }
    }, [_vm._v(_vm._s(c.label) + "\n            ")])
  }), 0), _vm._v(" "), _c('footer', {
    staticClass: "receipts-foot"
  }, [(!_vm.showCustomBillCashout) ? _c('button', {
    staticClass: "cart-confirm-button",
    attrs: {
      "disabled": _vm.customBillSubmitting
    },
    on: {
      "click": _vm.submitCustomBill
    }
  }, [(!_vm.customBillSubmitting) ? _c('span', [_vm._v("\n                   + " + _vm._s(_vm.locale.t('label_save_bill')) + "\n                ")]) : _c('span', [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_saving')) + "…\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.showCustomBillCashout) ? _c('button', {
    staticClass: "cart-confirm-button cashout",
    attrs: {
      "disabled": _vm.customBillSubmitting
    },
    on: {
      "click": _vm.submitCashoutBill
    }
  }, [(!_vm.customBillSubmitting) ? _c('span', [_vm._v("\n                   - " + _vm._s(_vm.locale.t('label_cash_cashout')) + "\n                ")]) : _c('span', [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_saving')) + "…\n                ")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showProfits) ? _c('div', {
    staticClass: "drawer-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeProfits.apply(null, arguments)
      }
    }
  }, [_c('aside', {
    staticClass: "bills-drawer bills-drawer--full",
    attrs: {
      "role": "dialog",
      "aria-label": _vm.locale.t('label_profit')
    }
  }, [_c('header', {
    staticClass: "receipts-head"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("💰 " + _vm._s(_vm.locale.t('label_profit')) + " " + _vm._s(_vm.formatMoney(_vm.totalProfit)) + " " + _vm._s(_vm.locale.t('label_currency')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_period')) + ": " + _vm._s(_vm.profitFromDate || '—') + " → " + _vm._s(_vm.profitToDate || '—') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "section-top-xxs"
  }, [_c('b', {
    staticClass: "title"
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_total_profit')) + " [" + _vm._s(_vm.selectedProfitTab === 'orders' ? _vm.locale.t('label_profit_tab_orders') : _vm.locale.t('label_profit_tab_payments')) + "]: " + _vm._s(_vm.formatMoney(_vm.activeTotalProfit)) + " " + _vm._s(_vm.locale.t('label_currency')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_items_count')) + ": " + _vm._s(_vm.activeProfitLines.length) + "\n                ")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn ghost",
    on: {
      "click": _vm.closeProfits
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_close')))])]), _vm._v(" "), _c('div', {
    staticClass: "receipts-filters"
  }, [_c('div', {
    staticClass: "search-main-wrap"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitFromDate),
      expression: "profitFromDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_from')
    },
    domProps: {
      "value": (_vm.profitFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitFromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('label', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profitToDate),
      expression: "profitToDate"
    }],
    staticClass: "search",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_to')
    },
    domProps: {
      "value": (_vm.profitToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profitToDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chips section-top-xs"
  }, [_c('button', {
    staticClass: "chip",
    class: {
      active: _vm.selectedProfitTab === 'orders'
    },
    on: {
      "click": function($event) {
        _vm.selectedProfitTab = 'orders'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_profit_tab_orders')) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "chip",
    class: {
      active: _vm.selectedProfitTab === 'payments'
    },
    on: {
      "click": function($event) {
        _vm.selectedProfitTab = 'payments'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_profit_tab_payments')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top"
  }, [_c('button', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.loadProfits()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_show')) + "\n              ")])])]), _vm._v(" "), (!_vm.profitsLoading && _vm.activeProfitLines.length) ? _c('div', {
    staticClass: "receipts-body"
  }, _vm._l((_vm.activeProfitLines), function(p) {
    return _c('div', {
      key: p.id || p.name,
      staticClass: "receipt-line"
    }, [_c('div', {
      staticClass: "receipt-top"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "name",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "gap": "10px"
      }
    }, [(p.image) ? _c('img', {
      staticClass: "item-thumb",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "8px"
      },
      attrs: {
        "src": p.image,
        "alt": ""
      }
    }) : _c('div', {
      staticClass: "cash-widget__icon",
      staticStyle: {
        "width": "32px",
        "height": "32px"
      }
    }, [_vm._v("🧾")]), _vm._v(" "), _c('span', {
      attrs: {
        "title": p.name
      }
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('span', {
      staticClass: "chip",
      staticStyle: {
        "height": "18px"
      }
    }, [_vm._v("\n                × " + _vm._s(p.quantity) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "total",
      staticStyle: {
        "color": "green"
      }
    }, [_c('b', [_vm._v("+" + _vm._s(_vm.formatMoney(p.profit)))])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.profitsLoading && !_vm.activeProfitLines.length) ? _c('div', {
    staticClass: "receipts-empty"
  }, [_c('div', [_vm._v("😐 " + _vm._s(_vm.locale.t('label_no_profit_data_for_period')))])]) : _vm._e(), _vm._v(" "), (_vm.profitsLoading) ? _c('div', {
    staticClass: "receipts-loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.showCustomerForm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6112e9e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BarPos/BarPos.vue
// module id = 793
// module chunks = 0